import React from "react"
//import I18n from "i18n-js/index.js.erb"
import DataTable from "../../../DataTable/DataTable"

class NightAuditFolioItemsFees extends React.Component {
  constructor(props) {
    super(props)
    this.itemsAndTotal = this.itemsAndTotal.bind(this)
  };

  shouldComponentUpdate(nextProps, nextState) {
    if ((this.props.totals.fees === nextProps.totals.fees) && (this.props.excludedFolioItems === nextProps.excludedFolioItems) && (this.props.postDate === nextProps.postDate)) {
      return false
    } else {
      return true
    };
  };

  render() {
    return (
      <div className="panel panel-default">
        <div className="panel-body">
          <h3 className="panel-heading-text">{I18n.t('fees')} - {I18n.t('total')} {this.props.totals.fees ? this.props.formatCurrency(this.props.totals.fees) : this.props.formatCurrency(0)} - <span className="ss-help help" title={I18n.t('night_audit_count_helper_text')}></span> {I18n.t('item_count')} {this.props.totals.fees_count ? this.props.totals.fees_count : 0}</h3>
          <div className="col-sm-12">
            <DataTable 
            endpoint={`/admin/night-audits/${this.props.excludedFolioItems.length ? this.props.excludedFolioItems : false}/fees-data-table`} 
            date_format={this.props.date_format} 
            time_format={this.props.time_format}
            delimiter={I18n.t('number.currency.format.delimiter')} 
            separator={I18n.t('number.currency.format.separator')} 
            itemsAndTotal={this.itemsAndTotal} 
            night_audit={true} 
            audit_date={this.props.postDate} 
            excluded_folio_items={this.props.excluded_folio_items} 
            exclude={this.props.excludeFolioItems} 
            />
          </div>
        </div>
      </div>
    );
  };

  itemsAndTotal(items, total, count) {
    this.props.collectDataAndTotals('fees', total, count)
  };
};

export default NightAuditFolioItemsFees